import React from "react";
import { useEffect, useState } from "react";
import { Form, FormGroup, Input, Label, Table } from "reactstrap";
import "./Ratio.css";

//ratio function
export function Ratio({ selectedLeague }) {
  const [data, setData] = useState([]);
  const [totalSH, setTotalSH] = useState(0);
  const [scorehomeAverage, setscorehomeAverage] = useState(0);
  const [attackingHome, setAttackingHome] = useState(0);
  const [totalCH, setTotalCH] = useState(0);
  const [concededhome_average, setconcededhome_average] = useState(0);
  const [defensive_home, setdefensive_home] = useState(0);
  //total sa
  const [totalSA, setTotalSA] = useState(0);
  const [scoredaway_average, setscoredaway_average] = useState(0);
  const [attacking_away, setattacking_away] = useState(0);
  //total ca
  const [TotalCA, setTotalCA] = useState(0);
  const [concededaway_average, setconcededaway_average] = useState(0);
  const [defensive_away, setdefensive_away] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [isEmpty, setIsEmpty] = useState(false);
  const API_URL = process.env.REACT_APP_DIRECT || "http://192.168.1.103:8081";

  useEffect(() => {
    console.log(`Fetching data for league: ${selectedLeague}`);

    if (selectedLeague) {
      fetch(`${API_URL}/table/${selectedLeague}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.length === 0) {
            setIsEmpty(true);
            setRowCount(0); // Set row count to 0 when there's no data
            console.log("No data to be displayed");
          } else {
            setIsEmpty(false);
            console.log("Fetched data:", data);
            setRowCount(data.length); // Set row count only when there's data
            setData(data);

            const totalSH = data.reduce(
              (accumulator, currentValue) =>
                accumulator + parseFloat(currentValue.SH),
              0
            );
            const totalCH = data.reduce(
              (accumulator, currentValue) =>
                accumulator + parseFloat(currentValue.CH),
              0
            );
            const totalSA = data.reduce(
              (accumulator, currentValue) =>
                accumulator + parseFloat(currentValue.SA),
              0
            );
            const totalCA = data.reduce(
              (accumulator, currentValue) =>
                accumulator + parseFloat(currentValue.CA),
              0
            );

            setTotalSH(totalSH.toFixed(2));
            setTotalCH(totalCH.toFixed(2));
            setTotalSA(totalSA.toFixed(2));
            setTotalCA(totalCA.toFixed(2));

            // Calculate averages
            const scorehomeAverage = parseFloat(
              (totalSH / data.length).toFixed(2)
            );
            const concededhome_average = parseFloat(
              (totalCH / data.length).toFixed(2)
            );
            const scoredaway_average = parseFloat(
              (totalSA / data.length).toFixed(2)
            );
            const concededaway_average = parseFloat(
              (totalCA / data.length).toFixed(2)
            );

            setscorehomeAverage(scorehomeAverage);
            setconcededhome_average(concededhome_average);
            setscoredaway_average(scoredaway_average);
            setconcededaway_average(concededaway_average);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [selectedLeague]); // Only fetch when selectedLeague changes

  useEffect(() => {
    // Calculate attacking and defensive strengths whenever data changes
    if (data.length > 0) {
      console.log("totalSH:", totalSH);
      console.log("data.length:", data.length);
      console.log("scorehomeAverage:", scorehomeAverage);
      console.log(
        "Sample SH values:",
        data.map((item) => item.SH)
      );
      const attackingHome = data.map((item) =>
        parseFloat((item.SH / scorehomeAverage).toFixed(2))
      );
      setAttackingHome(attackingHome);

      const defensive_home = data.map((item) =>
        parseFloat((item.CH / concededhome_average).toFixed(2))
      );
      setdefensive_home(defensive_home);

      const attacking_away = data.map((item) =>
        parseFloat((item.SA / scoredaway_average).toFixed(2))
      );
      setattacking_away(attacking_away);

      const defensive_away = data.map((item) =>
        parseFloat((item.CA / concededaway_average).toFixed(2))
      );
      setdefensive_away(defensive_away);
    }
  }, [
    data,
    scorehomeAverage,
    concededhome_average,
    scoredaway_average,
    concededaway_average,
  ]); // Calculate strengths when these values change

  return (
    <>
      <div className="alg1_card">
        <Table striped>
          <thead>
            <tr>
              <th scope="col">Pos {TotalCA} </th>
              <th scope="col">Team</th>
              <th scope="col">Match_played</th>
              <th scope="col">scored PG(H)</th>
              <th scope="col">Astrength(H)</th>
              <th scope="col">Conceded PG(H)</th>
              <th scope="col">Dstrength(H)</th>
              <th scope="col">scored PG(A)</th>
              <th scope="col">Astrength(A)</th>
              <th scope="col">conceded PG(A)</th>
              <th scope="col">Dstrength(A)</th>
              <th scope="col">Points</th>
              <th>pr_GP</th>
              <th>pr_Gol</th>
              <th>pr_GD</th>
              <th>More </th>
            </tr>
          </thead>
          <tbody>
            {data.map((d, i) => (
              <tr key={i}>
                <th scope="row">{d.Pos}</th>
                <td className="teamName">{d.Team}</td>
                <td>{d.MP}</td>
                <td>{d.SH}</td>
                <td> {attackingHome[i]} </td>
                <td>{d.CH}</td>
                <td>{defensive_home[i]}</td>
                <td> {d.SA} </td>
                <td>{attacking_away[i]} </td>
                <td>{d.CA} </td>
                <td>{defensive_away[i]} </td>
                <td>{d.PTS}</td>
                {/*confrim11*/}
                <td
                  style={{
                    background: d.H_P + d.A_P === d.MP ? "green" : "red",
                    color: "white",
                  }}
                >
                  p
                </td>

                <td
                  style={{
                    background: d.S_Home + d.S_Away === d.G ? "green" : "red",
                    color: "white",
                  }}
                >
                  p
                </td>

                <td
                  style={{
                    background:
                      d.S_Home + d.S_Away - (d.C_Home + d.C_Away) === d.GD
                        ? "green"
                        : "red",
                    color: "white",
                  }}
                >
                  p
                </td>
                {/*default*/}
                <td
                  className={`linktag ${
                    d.H_P + d.A_P !== d.MP ||
                    d.S_Home + d.S_Away !== d.G ||
                    d.S_Home + d.S_Away - (d.C_Home + d.C_Away) !== d.GD
                      ? ""
                      : ""
                  }`}
                >
                  <a
                    href={`/Goto?HP=${d.H_P}&ASH=${scorehomeAverage}&count=${rowCount}&ASA=${scoredaway_average}&Team=${d.Team}&attack_home=${attackingHome[i]}&defensive_home=${defensive_home[i]}&leagueselected=${selectedLeague}&home_position=${d.Pos} `}
                  >
                    More
                  </a>
                </td>
                {/* team_form_average*/}
                <td
                  className={`linktag ${
                    d.H_P + d.A_P !== d.MP ||
                    d.S_Home + d.S_Away !== d.G ||
                    d.S_Home + d.S_Away - (d.C_Home + d.C_Away) !== d.GD
                      ? "hide"
                      : ""
                  }`}
                >
                  <a
                    href={`/Form_factor?HP=${d.H_P}&ASH=${scorehomeAverage}&count=${rowCount}&ASA=${scoredaway_average}&Team=${d.Team}&attack_home=${attackingHome[i]}&defensive_home=${defensive_home[i]}&leagueselected=${selectedLeague}&home_position=${d.Pos} `}
                  >
                    F_avrg
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}
